/* ============================================================================
   Furniva cart behaviour.

   The cart page is a real form: quantity inputs are `updates[]`, Remove is a
   link to /cart/change, and the submit button goes to checkout. Everything here
   makes those instant instead of a page reload, and falls back to the plain
   behaviour on any error.
   ============================================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-fv-cart]');
  if (!root) return;

  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }
  function $$(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }
  function on(el, type, handler, options) {
    if (el) el.addEventListener(type, handler, options);
  }

  var routeRoot =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  /* --------------------------------------------------------------------------
     Summary disclosure (below 1024px).
     -------------------------------------------------------------------------- */
  (function summary() {
    var toggle = $('[data-fv-summary-toggle]');
    var body = $('[data-fv-summary-body]');
    if (!toggle || !body) return;

    var mq = window.matchMedia('(max-width: 1023.98px)');
    function sync() {
      if (mq.matches) {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        body.hidden = !open;
      } else {
        // Above the breakpoint the summary is always open, and the toggle is
        // hidden by CSS — so the body must not stay collapsed from a narrow view.
        body.hidden = false;
      }
    }
    on(toggle, 'click', function () {
      toggle.setAttribute('aria-expanded', toggle.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
      sync();
    });
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else if (mq.addListener) mq.addListener(sync);
    sync();
  })();

  /* --------------------------------------------------------------------------
     Re-render the cart from the server so every total, badge and alert comes
     from Liquid rather than being recomputed in JS. Two sources of truth for a
     price is how a cart starts lying.
     -------------------------------------------------------------------------- */
  function refresh() {
    return fetch(window.location.pathname + window.location.search, {
      headers: { 'X-Requested-With': 'fetch' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart reload failed: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var next = parsed.querySelector('[data-fv-cart]');
        if (!next) throw new Error('Cart markup missing from response');
        // Already on the page: its entrance has played and must not replay.
        next.classList.add('is-refreshed');
        root.replaceWith(next);
        root = next;
        // The suggestions came back as fresh server markup — including one that
        // may have just been added to the cart and is now correctly absent.
        shuffleAddons();
        // The suggestions are the catalogue's own cards in a shared rail, and
        // both are wired on load: arrows by furniva.js, hearts, finish dots and
        // photo fades on the event every other surface raises for new cards.
        // Both binders skip what is already bound.
        if (window.furnivaInitRails) window.furnivaInitRails(root);
        document.dispatchEvent(new CustomEvent('furniva:collection:updated'));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      });
  }

  /* Discount codes on the cart itself (/cart/update.js `discount`), so the
     order summary prices them, and the one Razorpay Magic Checkout is handed
     (snippets/furniva-checkout-code.liquid). `codes` is the whole set to keep:
     one coupon and a coins code side by side. Exposed for furniva-coins.js. */
  function appliedCodes() {
    return String(root.getAttribute('data-fv-codes') || '').split(',').map(function (c) { return c.trim(); }).filter(Boolean);
  }
  function setCodes(codes) {
    setBusy(true);
    return fetch(routeRoot + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Discount update failed: ' + response.status);
        return refresh();
      })
      .then(function () {
        // Magic Checkout prices only the code it is handed when it opens
        // (snippets/furniva-checkout-code.liquid).
        if (window.furnivaCheckoutCode) window.furnivaCheckoutCode(appliedCodes());
      })
      .catch(function () { window.location.reload(); })
      .then(function () { setBusy(false); });
  }
  // What is on the cart right now, from Shopify (`discount_codes`), so a
  // change never drops a code the page did not know about.
  function liveCodes() {
    return fetch(routeRoot + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : Promise.reject(); })
      .then(function (cart) { return (cart.discount_codes || []).map(function (d) { return d.code; }).filter(Boolean); })
      .catch(function () { return appliedCodes(); });
  }
  window.FurnivaCart = {
    codes: function () { return appliedCodes(); },
    // One coupon at a time, plus coins (owner, 2026-10-01): a new coupon
    // replaces the one on the cart; a coins code (FC-…) sits beside it.
    // Shopify enforces the same through each discount's combinations.
    addCode: function (code) {
      var isCoins = function (c) { return /^FC-/i.test(c); };
      return liveCodes().then(function (codes) {
        // Magic Checkout takes one code: a coupon added while coins are on the
        // cart is folded into a new coins code instead (furniva-coins.js).
        if (!isCoins(code) && codes.some(isCoins) && window.FurnivaCoins && window.FurnivaCoins.stack) {
          return window.FurnivaCoins.stack(code);
        }
        var keep = codes.filter(function (c) {
          if (c.toUpperCase() === String(code).toUpperCase()) return false;
          return isCoins(code) ? !isCoins(c) : isCoins(c);
        });
        return setCodes(keep.concat([code]));
      });
    },
    // Exactly these codes on the cart, nothing else (a stacked coins code
    // replaces the coupon it carries).
    replaceCodes: function (codes) { return setCodes(codes); },
    removeCode: function (code) {
      return liveCodes().then(function (codes) {
        return setCodes(codes.filter(function (c) { return c.toUpperCase() !== String(code).toUpperCase(); }));
      });
    }
  };

  function setBusy(state) {
    root.setAttribute('aria-busy', state ? 'true' : 'false');
    root.style.opacity = state ? '0.6' : '';
    root.style.pointerEvents = state ? 'none' : '';
  }

  /* `leaving`, when given, is the line on its way out: it glides away while
     the server updates, nothing else dims, and the cart redraws once both are
     done, so the list closes up instead of jumping (owner, 2026-10-10).
     `note` is the confirmation shown afterwards. */
  function change(body, leaving, note) {
    if (leaving) {
      root.setAttribute('aria-busy', 'true');
      root.style.pointerEvents = 'none';
    } else {
      setBusy(true);
    }
    var motion = leaving && window.FurnivaMotion ? window.FurnivaMotion.leave(leaving) : Promise.resolve();
    return Promise.all([fetch(routeRoot + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }), motion])
      .then(function (both) {
        var response = both[0];
        if (!response.ok) throw new Error('Cart change failed: ' + response.status);
        return refresh();
      })
      .then(function () {
        if (note && window.FurnivaToast) window.FurnivaToast.show(note.text, note.link);
      })
      .catch(function () {
        // Let the browser do it the slow, reliable way.
        window.location.reload();
      })
      .then(function () {
        setBusy(false);
      });
  }

  /* --------------------------------------------------------------------------
     Delegated handlers — the cart re-renders itself, so binding to the document
     keeps them working after every swap.
     -------------------------------------------------------------------------- */
  /* Suggestions, in random order.

     Liquid renders a bounded pool of eligible products — in stock, imaged,
     priced, not already in the cart. Shuffling the nodes changes which cards
     are first in view without this file deciding anything about eligibility,
     and without a second request. If this never runs, Liquid's order stands. */
  function shuffleAddons() {
    var box = $('[data-fv-addons]');
    if (!box) return;
    var rail = box.querySelector('[data-fv-rail]') || box;
    var items = $$('[data-fv-addon]', box);
    if (items.length < 3) return; // nothing to choose between
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = items[i];
      items[i] = items[j];
      items[j] = tmp;
    }
    // Back into the rail, not the section — appending to the section would lift
    // every card out of the scroller and leave it under the heading.
    items.forEach(function (node) { rail.appendChild(node); });
  }

  shuffleAddons();

  /* Copy the first-order code.

     The code is selectable text with or without this, so a browser that refuses
     the clipboard — an insecure origin, a permission denied — loses a
     convenience and nothing else. The label says what happened either way, so
     nobody is left wondering whether the tap did anything. */
  on(document, 'click', function (event) {
    var apply = event.target.closest && event.target.closest('[data-fv-code-apply]');
    if (apply) {
      event.preventDefault();
      apply.disabled = true;
      window.FurnivaCart.addCode(apply.getAttribute('data-fv-code-apply'));
      return;
    }
    var drop = event.target.closest && event.target.closest('[data-fv-code-remove]');
    if (drop) {
      event.preventDefault();
      drop.disabled = true;
      window.FurnivaCart.removeCode(drop.getAttribute('data-fv-code-remove'));
      return;
    }
    var copy = event.target.closest && event.target.closest('[data-fv-copy]');
    if (copy) {
      event.preventDefault();
      var label = copy.querySelector('[data-fv-copy-label]');
      var said = function (text, ok) {
        if (!label) return;
        label.textContent = text;
        copy.classList.toggle('is-copied', Boolean(ok));
        clearTimeout(copy.fvCopyTimer);
        copy.fvCopyTimer = setTimeout(function () {
          label.textContent = 'Tap to copy';
          copy.classList.remove('is-copied');
        }, 2400);
      };
      var code = copy.getAttribute('data-fv-copy') || '';
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code)
          .then(function () { said('Copied', true); })
          .catch(function () { said('Select and copy'); });
      } else {
        said('Select and copy');
      }
      return;
    }

    /* Save for later: into the saved list, out of the cart.

       The save happens first and the line is removed only if it succeeded, so a
       storage failure leaves the cart as it was rather than losing the piece
       from both places. A piece already saved is not duplicated — it is simply
       taken out of the cart. */
    var save = event.target.closest('[data-fv-cart-save]');
    if (save && root.contains(save)) {
      event.preventDefault();
      var wishlist = window.FurnivaWishlist;
      var handle = save.dataset.fvSaveHandle || '';
      if (!wishlist || typeof wishlist.add !== 'function' || !handle) {
        // Without the saved list this control cannot do what it says, so it
        // does nothing rather than quietly removing the line instead.
        return;
      }
      if (!(typeof wishlist.has === 'function' && wishlist.has(handle))) {
        wishlist.add({
          handle: handle,
          title: save.dataset.fvSaveTitle || '',
          url: save.dataset.fvSaveUrl || '',
          image: save.dataset.fvSaveImage || '',
          savedAt: Date.now()
        });
      }
      change(
        { line: parseInt(save.dataset.fvCartSave, 10), quantity: 0 },
        save.closest('.fv-cartitem'),
        { text: 'Saved for later', link: { href: '/pages/wishlist', label: 'View saved' } }
      );
      return;
    }

    var remove = event.target.closest('[data-fv-remove]');
    if (remove && root.contains(remove)) {
      event.preventDefault();
      change(
        { line: parseInt(remove.dataset.fvRemove, 10), quantity: 0 },
        remove.closest('.fv-cartitem'),
        { text: 'Removed from cart' }
      );
      return;
    }
  });

  /* Quantity is a select, so a change is a decision — there is no half-typed
     state to wait out. The drawer's select is the same control but outside
     this page's root; furniva-cart-drawer.js owns it. */
  on(document, 'change', function (event) {
    var control = event.target.closest('[data-fv-qty-select]');
    if (!control || !root.contains(control)) return;
    var holder = control.closest('[data-fv-qty]');
    if (!holder) return;
    var value = parseInt(control.value, 10);
    if (isNaN(value) || value < 0) value = 0;
    change({ line: parseInt(holder.dataset.fvLineIndex, 10), quantity: value });
  });

  /* There is no coupon field in this cart: discounts are entered and priced
     inside Razorpay Magic Checkout. The submit handler that used to sit here
     hijacked EVERY cart submit — Proceed to checkout included — whenever a
     discount field held a value, and sent the customer to /checkout?discount=,
     which bypasses Magic Checkout entirely. It is removed with the field. */
})();
